import { render, staticRenderFns } from "./requests-documents.vue?vue&type=template&id=2ff0b02b&"
import script from "./requests-documents.vue?vue&type=script&lang=js&"
export * from "./requests-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports